
import axiosInstance from '../axiosInstance';
import { useEffect, useMemo, useState, useRef } from 'react';
import { FaSearch } from 'react-icons/fa';

import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { API_URL_All } from '../api';
import * as general from '../libs/general';
import { fetchReconcilePartnerNormalPermissions } from "../libs/customerCreatePermission";
import Paging from '../components/Paging';
import { CheckingTicket, LockingTicket, WarningIcon, EyeIcon } from '../components/tickets/Tickets';
import ContactOrderReview from '../components/orders/ContactOrderReview';
import AdLayout from '../components/AdLayout';
import DataTable from '../components/ui/DataTable';

const isContactSelectLocked = (contactingId) => contactingId === 14 || contactingId === 15;

function ContactOrders() {
  //const [pageData, setPageData] = useState({ content: [] });
  const [pageOrderData, setPageOrderData] = useState({ content: [] });
  const [errorMessage, setErrorMessage] = useState("");

  const [checkingReviewData, setCheckingReviewData] = useState(null);

  const [searchQuery, setSearchQuery] = useState('');
  const [selectedOrders, setSelectedOrders] = useState([]);

  const hasRun = useRef(false);

  const [customerCodes, setCustomerCodes] = useState("");
  const [customerVats, setCustomerVats] = useState("");
  const [params, setParams] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [isChecking, setIsChecking] = useState(false);
  const [reconcilePerm, setReconcilePerm] = useState({
    loaded: false,
    canView: false,
    canCreate: false,
    canEdit: false,
  });

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const response = await axiosInstance.get(`/api/users/all`);
        const list = response.data.map(item => item.customerCode).filter(code => code);
        const uniqueList = [...new Set(list)];
        var joinedCodes = uniqueList.join(',');
        setCustomerCodes(joinedCodes);
      } catch (error) {
        console.error(error);
      }
    };

    fetchCustomers();
    searchOrders();
    //searchInvoices();
  }, []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const p = await fetchReconcilePartnerNormalPermissions(axiosInstance);
      if (!cancelled) {
        setReconcilePerm({
          loaded: true,
          canView: Boolean(p?.canView),
          canCreate: Boolean(p?.canCreate),
          canEdit: Boolean(p?.canEdit),
        });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const handleRefreshPage = (e) => {
    searchOrders();
    //searchInvoices();
  };


  const handleSearchCustomerChange = (e) => {
    var searchValue = e.target.value;

    var name = e.target.name;
    var newParams = { ...params };
    newParams[name] = e.target.value;
    setParams(newParams);

    var thTag = e.target.closest('.th-col');
    if (thTag) {
      var selectedTag = thTag.querySelector('.item_selected');
      if ((selectedTag && selectedTag.innerText === searchValue) || searchValue === '') {
        if (name === 'customerCode') {
          searchOrders({ page: 0, customerCode: searchValue, taxVat: '' });
        } else {
          searchOrders({ page: 0});
        }
      }
    }


  };

  const searchOrders = async (filter) => {
    if (window.calling) return;
    window.calling = true;

    setIsLoading(true);
    setIsSearching(true);
    setErrorMessage('');

    var checkAllTag = document.querySelector('.check_all');
    if (checkAllTag) {
      checkAllTag.removeAttribute('data-unchecked');
      checkAllTag.checked = false;
    }
    setSelectedOrders([]);

    var params = general.getSession('contact_order_filter');

    var formData = general.getFormData('#contact_order_filter');
    Object.assign(params, formData);

    if (!hasRun.current) {
      hasRun.current = true;
      var oldParams = general.getSession('contact_order_filter');
      Object.assign(params, oldParams);
      setSearchQuery(params.keyword);
    }

    if (filter) Object.assign(params, filter);
    general.setSession('contact_order_filter', params);
    setParams(params);
    window.initializeFilterValue(params);


    var filteredParams = Object.fromEntries(Object.entries(params).filter(([key, v]) => v !== undefined && v !== '' && key + v !== 'page0' && key + v !== 'size550' && key + v !== 'isDeletedfalse'));
    delete filteredParams.locked;
    filteredParams.excludeContactLocked = true;

    var response = {};

    setErrorMessage("");
    setPageOrderData({ content: [] });
    try {
      response = await axiosInstance.get('/api/import-orders/searchorders', { params: filteredParams });
      setPageOrderData(response.data);
      var processedOrders = response.data.page.content;
      //debugger;
      if (params.status) {
        var statusNames = params.status.split(';');
        var listStatus = response.data.orderStatus;
        listStatus.forEach(obj => {
          if (statusNames.includes(obj.name)) {
            obj.active = true;
          }
        });
      }

      var checkAllTag = document.querySelector('.check_all');
      if (checkAllTag) {
        checkAllTag.removeAttribute('data-listIds');
        if (response.data.listIds) {
          checkAllTag.setAttribute('data-listIds', response.data.listIds.join(","));
        }
        var uncheckedList = checkAllTag.getAttribute('data-unchecked');
        if (uncheckedList || checkAllTag.checked) {
          if (!uncheckedList) uncheckedList = '';
          var uncheckedItems = uncheckedList.split(',').map(item => parseInt(item.trim())).filter(Number.isInteger);
          setSelectedOrders(processedOrders
            .filter(order => !uncheckedItems.includes(order.id) && !isContactSelectLocked(order.contactingId))
            .map(order => order.id));
        }
      }
    } catch (error) {
      setErrorMessage(error.message);
      console.error(error);
    } finally {
      window.calling = false;
      setIsSearching(false);
      setIsLoading(false);
    }
  };

  const handleChangeItemsPerPage = (e) => {
    const newItemsPerPage = parseInt(e.target.value, 10);
    searchOrders({ page: 0, size: newItemsPerPage });
  };

  const handlePageChange = (page) => {
    searchOrders({ page: page - 1 });
  };

  const getSelectableListIds = () => {
    const content = pageOrderData.page?.content || [];
    const listIds = pageOrderData.listIds || content.map(o => o.id);
    const lockedIds = new Set(content.filter(o => isContactSelectLocked(o.contactingId)).map(o => o.id));
    return listIds.filter(id => !lockedIds.has(id));
  };

  const prepareChecking = async (params) => {
    if (isChecking) return;
    if (!reconcilePerm.loaded || !reconcilePerm.canCreate) {
      toast.warning("Bạn không có quyền tạo đối soát.");
      return;
    }
    const content = pageOrderData.page?.content || [];
    const lockedIds = new Set(content.filter(o => isContactSelectLocked(o.contactingId)).map(o => o.id));
    const selectableIds = selectedOrders.filter(id => !lockedIds.has(id));
    if (selectableIds.length < selectedOrders.length) {
      toast.warning("Đã loại các đơn Vào phiếu / Đã đối soát khỏi danh sách tạo đối soát.");
      setSelectedOrders(selectableIds);
    }
    if (selectableIds.length === 0) {
      toast.error('Phải chọn ít nhất một mục.');
      return;
    }
    setIsChecking(true);
    try {
      var reviewParams = { listIds: selectableIds };
      var isValid = await validateInvoice(reviewParams);
      if (isValid) setCheckingReviewData(reviewParams);
    } finally {
      setIsChecking(false);
    }
  };

  const validateInvoice = async (params) => {
    try {
      var urlApi = `/api/invoices/getInvoiceContactReview`;
      var listIds = { codes: params.listIds.join(';') };
      const response = await axiosInstance.post(urlApi, listIds , 
        { headers: { 'Content-Type': 'application/json' } });
      var obj = response.data;
      if (obj.success === false) {
        toast.error(obj.message);
        return false;
      }
    } catch (error) {
      console.error(error);
      toast.error(error.message);
      return false;
    }
    return true;
  }

  function removeItem(array, value) {
    return array.filter(item => item !== value);
  }
  const handleSelectOrder = (id) => {
    const order = pageOrderData.page?.content?.find(o => o.id === id);
    if (order && isContactSelectLocked(order.contactingId)) return;

    setSelectedOrders((prevSelected) => {
      const updated = prevSelected.includes(id)
        ? prevSelected.filter((orderId) => orderId !== id)
        : [...prevSelected, id];

      var totalNumberPages = pageOrderData.page.totalPages;
      var checkallTag = document.querySelector('.check_all');
      const selectableListIds = getSelectableListIds();
      if (totalNumberPages === 1 && selectableListIds.length) {
        const allChecked = selectableListIds.every(orderId => updated.includes(orderId));
        if (checkallTag) checkallTag.checked = allChecked;
      }
      var isChecked = updated.includes(id);
      var uncheckedList = checkallTag.getAttribute('data-unchecked');
      var idText = id + '';
      if (totalNumberPages > 1 && (checkallTag.checked || uncheckedList)) {
        if (!uncheckedList) uncheckedList = '';
        var uncheckedItems = uncheckedList.split(',').filter(str => str !== "");
        if (isChecked) {
          uncheckedItems = removeItem(uncheckedItems, idText);
        } else {
          var isExisted = uncheckedItems.includes(idText);
          if (!isExisted) uncheckedItems.push(idText);
        }
        var textUncheckedItems = uncheckedItems.join(',');

        if (textUncheckedItems) {
          checkallTag.setAttribute('data-unchecked', textUncheckedItems);
          checkallTag.checked = false;
        } else {

          checkallTag.removeAttribute('data-unchecked');
          checkallTag.checked = true;
        }
      }

      return updated;
    }
    );
  };
  const handleSelectAll = () => {
    var checkAllTag = document.querySelector('.check_all');
    checkAllTag.removeAttribute('data-unchecked');
    var isChecked = checkAllTag.checked;
    if (!isChecked) {
      setSelectedOrders([]);
    } else {
      setSelectedOrders(getSelectableListIds());
    }
  };

  return (
    <div>
      <AdLayout>
        <div className="table-responsive web-table">
          <div className="tab-container">
            <nav>
              <div className="nav nav-tabs" id="nav-tab" role="tablist">
                <button className="nav-link active">Đối tác: Đơn hàng thường</button>
                <button className="nav-link"><Link to="/hoa-don-doi-tac">Đối tác: Đã đối soát</Link></button>
              </div>
            </nav>
            <div className="tab-content bg-white" id="nav-tabContent">
              <div className="tab-pane fade show active" id="pane-01" role="tabpanel" aria-labelledby="nav-home-tab">

                <div className="container-fluid pt-2">
                  <div className="text-start mb-2 normal-form">
                      <div className="row">
                      <div className="col-md-8">
                        <form id="contact_order_filter">
                          <div className="row">
                            <div className="col-5 height-46">
                              <div className="row">
                                <label className="form-label col-form-label col-md-3 text-end">Mã bao</label>
                                <div className="col-md-9">
                                  <div className="">
                                    <textarea name="sackCodes" className="form-control" placeholder="Mã bao"></textarea>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-5 height-46">
                              <div className="row">
                                <label className="form-label col-form-label col-md-3 text-end">Mã đơn vận</label>
                                <div className="col-md-9">
                                  <input name="lines" type="hidden" value="TMĐT;Line Thường;Line XT" />
                                  <div className="">
                                    <textarea name="chinaCodes" className="form-control" placeholder="Mã đơn vận"></textarea>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-2 p-0">

                              <button
                                onClick={() => searchOrders({ page: 0 })}
                                className="btn btn-light btn-sm d-inline-flex align-items-center justify-content-center zto-btn-icon-sm"
                                type="button"
                                title="Tìm kiếm..."
                                disabled={isSearching}
                                aria-busy={isSearching}
                              >
                                {isSearching ? (
                                  <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                ) : (
                                  <FaSearch />
                                )}
                              </button>
                            </div>
                          </div>

                          <button
                            onClick={() => searchOrders({ page: 0 })}
                            className="btn btn-light btn-sm d-none align-items-center justify-content-center"
                            type="button"
                            title="Tìm kiếm..."
                            disabled={isSearching}
                            aria-busy={isSearching}
                          >
                            {isSearching ? (
                              <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                            ) : (
                              <FaSearch />
                            )}
                          </button>
                        </form>
                      </div>
                      <div className="col-4 col-md-1 p-0">

                        <div>
                          {reconcilePerm.loaded && reconcilePerm.canCreate && (
                            <button 
                              onClick={(e) => prepareChecking(e)} 
                              type="button" 
                              className="btn btn-info btn-sm me-2 d-inline-flex align-items-center justify-content-center gap-1 zto-btn-min-122"
                              disabled={isChecking || isSearching}
                              aria-busy={isChecking}>
                              {isChecking ? (
                                <>
                                  <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                  Đang xử lý
                                </>
                              ) : (
                                'Tạo đối soát'
                              )}
                            </button>
                          )}
                        </div>
                      </div>

                      </div>

                  </div>
                </div>
                <section className="p-1 ">
                  <DataTable maxHeight="calc(100vh - 220px)" className="table-normal" data-loading={isLoading}>
                    <table className="table table-striped border-normal table-bordered">
                      <thead className="table-primary">
                        <tr>
                          <th className='sticky' width="21px">
                            <input type="checkbox" title='Check all' className='check_all' onChange={() => handleSelectAll()} />
                          </th>

                          <th className="text-center"><span>Ngày</span></th>
                          <th className="text-center">Mã bao</th>
                          <th className="text-center">Mã vận đơn TQ</th>
                          <th>Line</th>

                          <th className="text-center">Số kiện</th>
                          <th className="text-center"><span data-note="">Kg</span></th>
                          <th className="text-center"><span data-note="">M3</span></th>
                          <th className="text-center"><span data-note="">Phụ phí ĐT</span></th>

                          <th className="text-center">
                            <span data-note="">Thành tiền ĐT</span>
                            <span className="filter-ib" data-form="contact_order_filter" data-filter="contactRateStatus" data-source-key="list_rateStatus" data-min="100px"><i className="filter-i"></i></span>
                          </th>

                          <th>Lưu trình</th>
                          <th className="text-center">Mã KH</th>
                        </tr>
                      </thead>
                      {pageOrderData.page && pageOrderData.page.content && pageOrderData.page.content.map((item, index) => (
                        <tbody className="tbody-row">
                          <tr key={index}>
                            <td className='sticky' title={item.id}>
                              <input
                                type="checkbox"
                                checked={selectedOrders.includes(item.id)}
                                disabled={isContactSelectLocked(item.contactingId)}
                                onChange={() => handleSelectOrder(item.id)}
                              />
                            </td>

                            <td className="text-success text-center" title={general.formatTimeShort(item.createdDate)}>{general.formatDate(item.createdDate)}</td>
                            <td className="text-success text-center">{item.sackCode}</td>
                            <td className="text-success text-center">{item.cnShippingCode}</td>
                            <td className="text-success text-start">{item.lineName}</td>

                            <td className="text-success text-center">{general.formatNumber(item.packageNumbers)}</td>
                            <td className="text-success text-center">{general.formatDecimal(item.packageUnitValue)}</td>
                            <td className="text-success text-center">{general.formatDecimal(item.packageUnitM3)}</td>
                            <td title={`FeeWeight: ${general.formatNumber(item.feeWeight)} - FeeSize: ${general.formatNumber(item.feeSize)}`} className="text-success text-center">{general.formatNumber(item.contactFeeSurcharge)}</td>

                            <td className="text-success text-center">
                              <span className="pe-1">{general.formatNumber(item.contactFee)}</span>
                              <CheckingTicket checkingId={item.contactingId} checkingName={item.contactingName} />
                            </td>

                            <td className="text-success text-start">{item.statusName}</td>
                            <td className="text-success text-center">{item.customerCode}</td>
                          </tr>
                        </tbody>
                      ))}


                      <tbody>
                        {errorMessage === '' && pageOrderData.page && pageOrderData.page.content.length === 0 && (
                          <tr>
                            <td colSpan="21" className="text-center">Không tìm thấy dữ liệu</td>
                          </tr>
                        )}
                        {errorMessage !== '' && (
                          <tr>
                            <td colSpan="21" className="text-center">{errorMessage}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </DataTable>
                </section>
              </div>

            </div>


          </div>

          <div className="my-1 d-flex justify-content-end align-items-center">
              <Paging
                pageData={pageOrderData}
                onPageChange={handlePageChange}
                onItemsPerPageChange={handleChangeItemsPerPage}
                isShowTotal={true}
                showContactFeeTotal={true}
              />
          </div>


          <input type="hidden" id="editor_lines" value="TMĐT,Line Thường,Line XT" />
          <input type="hidden" id="list_lines" value="TMĐT,Line Thường,Line XT,Line VAT" />
          <input type="hidden" id="list_status" value="Đơn mới,Kho TQ,Xe Về VN,Kho VN,Đang Giao,Đã Nhận" />
          <input type="hidden" id="list_rateStatus" value="Chưa đối soát,Vào phiếu,Đã đối soát" />
          <input type="hidden" id="list_customers" value={customerCodes} />
          <input type="hidden" id="list_vats" value={customerVats} />

          <div className="d-none th-col th filter-check display">
            <span className="filter-ib" data-form="form_filter" data-filter="deletion"><input type="checkbox" /></span>
            <label className="form-check-label">Đã xóa</label>
          </div>
          <div className="d-none th-col th display">
            <span className="filter-ib" data-form="form_filter" data-filter="outdate"></span>
            <label className="form-check-label">Quá hạn</label>
          </div>

          {checkingReviewData && (
            <ContactOrderReview data={checkingReviewData} handleSearch={handleRefreshPage} canEdit={reconcilePerm.canEdit} />
          )}

        </div >
      </AdLayout>

  </div>
  );
}
export default ContactOrders;
